/** moderator/ontology — KEYS. */
export const ontologyKeys = {
  all: () => ['moderator', 'ontology'] as const,
  status: (matchId: string | null) => [...ontologyKeys.all(), 'status', matchId] as const,
  decisions: (matchId: string | null, cohortId: string | null) =>
    [...ontologyKeys.all(), 'decisions', matchId, cohortId] as const,
  evaluations: (matchId: string | null, cohortId: string | null) =>
    [...ontologyKeys.all(), 'evaluations', matchId, cohortId] as const,
  action: (matchId: string | null, actionId: string | null) =>
    [...ontologyKeys.all(), 'action', matchId, actionId] as const,
};
